import React, { useEffect, useRef, useState } from "react";
import Loader from "../../../components/ui/Loader/Loader";
import api from "../../../services/api";
import { useSelector } from "react-redux";
import { HRM_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import moment from "moment";
import Chart from "react-google-charts";
import DateService from "../../../services/DateService";
import TapIcon from "../../../services/TapIcon";
import UpdateMyDashboardForm from "../../settings/configurationGeneral/myDashboard/UpdateMyDashboardForm";
import Status from "../../../components/ui/Status";
import TapSelect from "../../../components/ui/TapSelect";
import DatePicker from "react-datepicker";

const EmployeeAttendanceWidget = (props) => {
    const updateMyDashboardRef = useRef();
    const widgeturl = HRM_API_BASE_URL_2 + "/attendance_status_widget"
    const widgetFormdataUrl = HRM_API_BASE_URL_2 + "/attendance_widget_formdata"
    const access_token = useSelector(state => state.auth.access_token)
    const iam_user_sites = useSelector(state => state.app.user_sites || []);
    const widget_keys = useSelector(state => state.app.user_info?.widget_keys || [])

    const [reload, setReload] = useState(false)
    const [widgetData, setWidgetData] = useState(null)
    const [attendanceData, setAttendanceData] = useState({
        loading: false,
        data: [],
        remark_time: ""

    })
    const [formData, setFormData] = useState({
        allSites: [],
        allDivision: [],
        filterData: {
            canChange: false,
            search_site_id: "",
            search_division_id: "",
            transaction_date: moment(new Date()).format("YYYY-MM-DD")
        }
    })
    useEffect(() => {
        if (!formData.filterData.canChange) return;
        attendanceWidgetData();
    }, [formData.filterData]);


    const fetchFormData = () => {
        api.server2Api.get(widgetFormdataUrl, {
            headers: { Authorization: 'Bearer ' + access_token }
        })
            .then((response) => {
                const data = response?.data?.division || [];

                const formattedDivision = data.map(w => ({
                    value: w.id,
                    label: w.name
                }));

                setFormData(pre => ({
                    ...pre,
                    allSites: iam_user_sites.map(w => ({
                        value: w.id,
                        label: w.site_name
                    })),
                    allDivision: formattedDivision
                }));

                localStorage.setItem("employeeAttendanceFormData", JSON.stringify({
                    allDivision: formattedDivision,
                    time: moment().format('DD-MM-YYYY HH:mm A')
                }));
            });
    };
    useEffect(() => {
        const cache = localStorage.getItem("employeeAttendanceFormData");

        if (cache) {
            const parsed = JSON.parse(cache);

            const diff = DateService.differenceInSeconds(
                moment(parsed.time, 'DD-MM-YYYY HH:mm A').format()
            );

            if (diff <= 86400) {
                setFormData(pre => ({
                    ...pre,
                    allSites: iam_user_sites.map(w => ({
                        value: w.id,
                        label: w.site_name
                    })),
                    allDivision: parsed.allDivision || []
                }));
                return;
            } else {
                localStorage.removeItem("employeeAttendanceFormData");
            }
        }
        fetchFormData();

    }, []);
    useEffect(() => {
        const widget = widget_keys?.length > 0
            ? widget_keys.find(w => w.key === "attendance_status_widget")
            : null;
        setWidgetData(widget)
    }, [])
    useEffect(() => {
        if (!reload) return;
        attendanceWidgetData();
        fetchFormData();
        setReload(false);
    }, [reload]);
    useEffect(() => {
        setAttendanceData(prev => ({ ...prev, loading: true }))
        const cache = localStorage.getItem("employeeAttendenceWidget")
        
        if (cache) {
            const parsed = JSON.parse(cache)
            const diff = DateService.differenceInSeconds(moment(parsed.time, 'DD-MM-YYYY HH:mm A').format());
            if (diff <= 86400) {

                setAttendanceData({
                    data: parsed.attendance_data,
                    loading: false,
                    remark_time: parsed.date
                });
                return;
            } else {
                localStorage.removeItem('employeeAttendenceWidget')
            }
        }
            attendanceWidgetData()

    }, [])
    const attendanceWidgetData = () => {
        setAttendanceData(prev => ({ ...prev, loading: true }))

        let params = {
            ...formData.filterData,
            reload: reload ? 'reload' : false

        }
        api.server2Api.get(widgeturl, { params: params, headers: { 'Authorization': 'Bearer ' + access_token } })
            .then((response) => {
                if (response.data) {
                    const resp = response.data
                    setAttendanceData({
                        data: resp?.attendance_data || [],
                        remark_time: resp.date,
                        loading: false
                    });

                    localStorage.setItem("employeeAttendenceWidget", JSON.stringify(resp))
                    
                }
            }).finally(() => {
                setAttendanceData(prev => ({ ...prev, loading: false }))
            })
    }
    const handleCountClick = (data) => {
        const statusId = data.key;
        const division = formData.filterData.search_division_id;
        const siteId = formData.filterData.search_site_id;
        const transactionDate = formData.filterData.transaction_date;
        
        const params = new URLSearchParams();
        if (statusId || statusId == 0) {
            params.append('attendance_status', statusId);
        }
        if (division) {
            params.append('division_id', division);
        }
        if (siteId) {
            params.append('site_id', siteId);
        }
        if (transactionDate) {
            params.append('transaction_date', transactionDate);
        }

        const url = `/hrm/daily_attendance?${params.toString()}`;
        window.open(url, '_blank');
    };
    const pinMyDashboardHandler = (widgetData = null) => {
        updateMyDashboardRef.current.updateMyDashboardModalInit(widgetData, {
            key: "attendance_status_widget",
            name: "Attendance Status Widget"
        });
    };
    const totalValue = attendanceData.data.reduce((acc, d) =>
        acc + (parseInt(d.count) > 0 ? parseInt(d.count) : 0), 0);

    return (
        <>
            <div className="card mt-3">
                <div className="card-body">
                    <div className="row align-items-center">
                        <div className="col-2">
                            <h6 className="fw-bold primary_color mb-0">Attendance Widget</h6>
                        </div>
                        <div className="col-3 p-0">
                            <TapSelect
                                options={formData.allDivision}
                                changeEvent={(selectOption) => {

                                    setFormData(prev => ({
                                        ...prev,
                                        filterData: {
                                            ...formData.filterData,
                                            canChange: true,
                                            search_division_id: selectOption ? selectOption.value : null
                                        }
                                    }));
                                }}
                                value={formData.allDivision.find(u => u.value === formData.filterData.search_division_id)}
                                isSearchable={true}
                                isClearable={true}
                                containerHeight="33px"
                                fontSize="93%"
                                width="99%"
                                placeholder="All Division"
                            />

                        </div>
                        <div className="col-3 ">
                                <DatePicker
                                    selected={
                                        formData?.filterData?.transaction_date
                                            ? moment(formData.filterData.transaction_date, "YYYY-MM-DD").toDate()
                                            : null
                                    }
                                    onChange={(date) => {
                                        setFormData((prev) => ({
                                            ...prev,
                                            filterData: {
                                                ...prev.filterData,
                                                canChange: true,
                                                transaction_date: moment(date).format("YYYY-MM-DD")
                                            }
                                        }));
                                    }}
                                    maxDate={new Date()}
                                    dateFormat="dd-MMM-yyyy"
                                    className="form-control custom-datepicker"
                                    placeholderText="Select Date"
                                />
                        </div>
                        <div className="col-3 p-0">
                            <TapSelect
                                options={formData.allSites}
                                changeEvent={(selectOption) => {
 
                                    setFormData(prev => ({
                                        ...prev,
                                        filterData: {
                                            ...formData.filterData,
                                            canChange: true,
                                            search_site_id: selectOption ? selectOption.value : null
                                        }
                                    }));
                                }}
                                value={formData.allSites.find(u => u.value === formData.filterData.search_site_id)}
                                isSearchable={true}
                                isClearable={true}
                                containerHeight="33px"
                                fontSize="93%"
                                width="99%"
                                placeholder="All Sites"
                            />

                        </div>
                        <div className="col-1 px-0 mx-0 text-center">
                            <div className="dropdown">
                                <TapIcon.imageIcon
                                    icon={TapIcon.ListActionIcon}
                                    alt="action-icon"
                                    className="img-fluid px-2 btn btn-light btn-block"
                                    data-bs-toggle="dropdown"
                                    href="#"
                                    role="button"
                                    aria-expanded="false"
                                />
                                <ul className="dropdown-menu dropdown-menu-end">
                                    <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => setReload(true)}>
                                        Refresh
                                    </li>
                                    <li className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => pinMyDashboardHandler(widgetData)}>
                                        {!widgetData ? "Pinned to My Dashboard" : "Unpinned from My Dashboard"}
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                    <div className="row align-items-center mt-2">
                        <div className="col-6">
                            <table className="table table-hover table-bordered  bg-white">
                                <thead className="table-secondary">
                                    <tr>
                                        <th style={{ width: "50%" }} className="text-start" >Status</th>
                                        <th style={{ width: "50%" }} className="text-center ">No. of Employees</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {attendanceData.loading ? (
                                        <tr>
                                            <td className="text-center" colSpan="2">
                                                <Loader />
                                            </td>
                                        </tr>
                                    ) : attendanceData.data && attendanceData.data?.length > 0 ?
                                        attendanceData.data.map((d, i) => (
                                            <tr key={i}>
                                                <td>  <Status color={d.color_code}>{d.name}</Status></td>
                                                <td className="text-center"
                                                    style={{ cursor: 'pointer' }} >
                                                        {d.count && d.count != 0 ? <span  className=" text-primary" onClick={() => handleCountClick(d)}>{d.count}</span> : "-"}</td>
                                            </tr>
                                        ))
                                        : <tr><td className="text-center" colSpan="2">No Records Found</td></tr>

                                    }
                                </tbody>
                                {!attendanceData.loading && attendanceData.data && attendanceData.data.length > 0 &&
                                    <tfoot>
                                        <tr className="fw-bold">
                                            <td>Total</td>
                                            <td className="text-center">{totalValue}</td>
                                        </tr>
                                    </tfoot>}
                            </table>
                        </div>
                        <div className="col-6 p0 mt-3 mb-1">
                            {attendanceData.loading ? (
                                <Loader />
                            ) : attendanceData.data ? (
                                <Chart
                                    chartType="PieChart"
                                    data={[['Status Name', 'Count']].concat(attendanceData.data.map((d) => {
                                        return [d.name, Number(d.count)]
                                    }))}
                                    options={{
                                        legend: { position: 'labeled', labeledValueText: 'both' },
                                        pieSliceText: 'none',
                                        chartArea: { width: '90%', height: '90%' },
                                    }}
                                    rootProps={{ 'data-testid': '1' }} />
                            ) : null}
                        </div>
                    </div>
                    <div className="col-sm-12 text-muted fs11">
                        Report as of {attendanceData.remark_time}
                    </div>
                </div>
                <UpdateMyDashboardForm ref={updateMyDashboardRef} />

            </div>
        </>
    )


}
export default EmployeeAttendanceWidget